export const APPLICATION_SET = 'APPLICATION_SET';

export const GET_COMPETITION_PHOTOS_FROM_MEMBER = 'GET_COMPETITION_PHOTOS_FROM_MEMBER';
export const GET_COMPETITION_PHOTOS_FROM_MEMBER_SUCCESS = 'GET_COMPETITION_PHOTOS_FROM_MEMBER_SUCCESS';
export const GET_COMPETITION_PHOTOS_FROM_MEMBER_ERROR = 'GET_COMPETITION_PHOTOS_FROM_MEMBER_ERROR';

